const translations = {
    en: {
      header: "Hello, I'm Burak Fevzi KAR",
      about: "About Me",
      experience: "My Experience",
      projects: "My Projects",
      contact: "Contact Me",
      send: "Send Message",
      cv:"Download CV",
    },
    tr: {
      header: "Merhaba, Ben Burak Fevzi KAR",
      about: "Hakkımda",
      experience: "Deneyimlerim",
      projects: "Projelerim",
      contact: "Bana Ulaşın",
      send: "Mesaj Gönder",
      cv:"CV'yi indir",
    },
  };
  
  export default translations;
  